// removed by extract-text-webpack-plugin
module.exports = {"background-overlay":"dh-dh-plast-quiz-background-overlay","background-overlay--darkest":"dh-dh-plast-quiz-background-overlay--darkest","background-overlay--extra-dark":"dh-dh-plast-quiz-background-overlay--extra-dark","background-overlay--dark":"dh-dh-plast-quiz-background-overlay--dark","background-overlay--light":"dh-dh-plast-quiz-background-overlay--light","background-overlay--extra-light":"dh-dh-plast-quiz-background-overlay--extra-light","background-overlay--lightest":"dh-dh-plast-quiz-background-overlay--lightest"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Background/Overlay.css
// module id = 39
// module chunks = 0